<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">佣金明细</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>


    <div class="sign-record">
      <div class="list">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="data">{{ item._add_month }} <router-link  :to="{ path: '/user/commission_day/' + item._add_month }" style="float:right;" class="bonus_show">明细</router-link></div>
          <div class="listn">
          <div class="itemn acea-row row-between-wrapper">

            <div class="name line1" style="width:50%;">汇总</div>
            <div style="float:right;width:50%;text-align:right;" class="num">
              {{item['all_money']}}
            </div>

          </div>
        </div>

          <div class="listn" v-for="(val, key) in allBonus" :key="key">
            <div class="itemn acea-row row-between-wrapper">

                <div class="name line1" style="width:50%;">{{ val.name }}</div>
                <div style="float:right;width:50%;text-align:right;color:#666;" class="num">
                  {{item[val['id']]}}
                </div>



            </div>
          </div>
        </div>
      </div>
    </div>



    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#018079;
    font-size:0.2rem;
  }
</style>

<script>
import {  getBonusListMonth } from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "CommissionDetailsMonth";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
        allBonus:[],
      commission: 0,
        allBonusCountCan:2,
      where: {
        page: 1,
        limit: 20
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getBonusListMonth(that.where).then(
        res => {
          that.loading = false;

          that.allBonus = res.data.allBonus;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
          that.commission = res.data.allmoney;

        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
